import { formatNumber } from 'libphonenumber-js'
import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import styled from 'styled-components'
import * as routeService from '../../services/routeService'
import { ActionList, DropdownMenu, Icon, Image, Stack } from './../'
import logoEN from './../../assets/images/logo-en_US.png'
import logoFR from './../../assets/images/logo-fr_FR.png'
import logoNL from './../../assets/images/logo-nl_BE.png'
import logoRentio from './../../assets/images/logo-rentio.png'
import * as translationService from './../../services/translationService'
import * as userService from './../../services/userService'
import { classNames } from './../../utils/styles'
import styles from './Layout.scss'

const StyledLanguageSelector = styled.span`
  color: ${props => props.isActive && props.theme.primaryColor};
`

const StyledUserMenuButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.ink.lighter};
  cursor: pointer;
  &:hover,
  &:focus {
    outline: none;
    color: ${({ theme }) => theme.colors.primary.base};
  }
`

const Layout = ({ children, isAuthenticated, user }) => {
  const changeLanguage = language => {
    translationService.changeLocale(language.locale)
  }

  const currentLocale = translationService.currentLocale()

  const logo = (() => {
    switch (currentLocale) {
      case 'fr_FR':
        return logoFR

      case 'en_US':
        return logoEN

      case 'nl_BE':
      default:
        return logoNL
    }
  })()

  const userMenuActions = [
    { content: translationService.usermenuProfile(), onClick: () => routeService.goToProfilePage() },
    { content: translationService.usermenuHistory(), onClick: () => routeService.goToPath('/profiel/aanvragen') },
    { content: translationService.usermenuAccount(), onClick: () => routeService.goToPath('/profiel/account') },
    { content: translationService.t('nav.logout'), onClick: userService.logOutUser },
  ]

  const renderLanguages = () => (
    <Stack divider="|" className={styles.Languages} spacing="tight">
      {translationService.getSupportedLanguages().map(language => (
        <StyledLanguageSelector
          role="button"
          isActive={currentLocale === language.locale}
          onClick={() => changeLanguage(language)}
          key={language.locale}>
          {language.value}
        </StyledLanguageSelector>
      ))}
    </Stack>
  )

  return (
    <div className={styles.Page}>
      <header className={styles.Header}>
        <div className={classNames(styles.Container, styles.HeaderContent)}>
          <div className={styles.Logo}>
            <Image source={logo} />
          </div>
          <div className={styles.Actions}>
            {isAuthenticated && (
              <div className={styles.UserMenu}>
                <DropdownMenu content={<ActionList items={userMenuActions} />} trigger="click" placement="bottom-end">
                  <StyledUserMenuButton>
                    {user.firstname || user.lastname
                      ? `${user.firstname} ${user.lastname}`
                      : formatNumber(user.mobileNumber || '', 'International')}{' '}
                    <Icon source="chevronDown" />
                  </StyledUserMenuButton>
                </DropdownMenu>
              </div>
            )}
            {renderLanguages(isAuthenticated)}
          </div>
        </div>
      </header>
      <div className={classNames(styles.Container, styles.Content)}>{children}</div>
      <footer className={styles.Footer}>
        <div className={styles.Container}>
          <Stack alignment="center" distribution="trailing">
            <Stack alignment="center">
              <Link to="/privacy">{translationService.privacyTitle()}</Link>
            </Stack>
            <Stack alignment="center">
              <span>Powered by</span>
              <Image alt="Rentio" source={logoRentio} />
            </Stack>
          </Stack>
        </div>
      </footer>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.any,
  user: PropTypes.any,
  isAuthenticated: PropTypes.any,
  reference: PropTypes.any,
}

const mapStateToProps = ({ AuthReducer }) => {
  const { user = {} } = AuthReducer
  const { isAuthenticated } = user
  return {
    user,
    isAuthenticated,
  }
}

export default compose(
  translate('translations'),
  connect(mapStateToProps),
)(Layout)



// WEBPACK FOOTER //
// ./src/components/Layout/index.js